import React, { useEffect, useState } from "react";
import { Pin, PinOff } from "lucide-react";
import { apiClient } from "@/lib/apiClient";
import { toast } from "sonner";

/** Merkt sich pro Nutzer & Firma, welcher Filter beim Öffnen der Seite standardmässig aktiv ist (geräteübergreifend). */
export function useDefaultFilter(prefKey, companyId, value, setValue) {
  const key = companyId ? `${companyId}:${prefKey}` : null;
  const field = key ? key.replace(/\./g, "_") : null;
  const [defaultValue, setDefaultValue] = useState(undefined);

  useEffect(() => {
    if (!field) return;
    let alive = true;
    apiClient.get("/auth/me/ui-prefs").then((r) => {
      if (!alive) return;
      const d = r.data?.prefs?.[field];
      setDefaultValue(d ?? null);
      if (d) setValue(d);
    }).catch(() => alive && setDefaultValue(null));
    return () => { alive = false; };
    // eslint-disable-next-line
  }, [field]);

  const save = async (v) => {
    const r = await apiClient.put("/auth/me/ui-prefs", { key, value: v });
    setDefaultValue(r.data?.prefs?.[field] ?? null);
  };
  return { defaultValue, save, isDefault: defaultValue != null && defaultValue === value };
}

export function DefaultFilterPin({ value, label, defaultValue, isDefault, onSave, testId = "default-filter-pin" }) {
  if (defaultValue === undefined) return null;
  const click = async () => {
    try {
      if (isDefault) {
        await onSave(null);
        toast.success("Standard entfernt – die Seite öffnet wieder mit der Grundeinstellung");
      } else {
        await onSave(value);
        toast.success(`«${label}» ist jetzt dein Standard beim Öffnen dieser Seite`);
      }
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Standard konnte nicht gespeichert werden");
    }
  };
  return (
    <button
      type="button"
      onClick={click}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-1 text-[11px] transition-colors ${isDefault ? "border-violet-300 bg-violet-50 text-violet-800" : "border-slate-200 text-slate-500 hover:bg-slate-50 hover:text-slate-700"}`}
      title={isDefault ? "Dieser Filter ist dein Standard – klicken zum Entfernen" : "Diesen Filter als Standard beim Öffnen merken"}
      data-testid={testId}
    >
      {isDefault ? <Pin className="h-3 w-3 fill-current" /> : <PinOff className="h-3 w-3" />}
      {isDefault ? "Standard" : "Als Standard"}
    </button>
  );
}
